<template>
	<component
		class="chip"
		:class="{ 'chip--default': !color }"
		:is="to ? 'a' : 'span'"
		:href="to || null"
		:style="style"
	>
		<span>
			{{ label }}
		</span>
		<span v-if="badge" class="chip__badge">
			{{ badge }}
		</span>
		<slot></slot>
	</component>
</template>

<script>
export default {
	name: 'DefaultChip',
	props: {
		badge: { type: String, required: false },
		color: { type: String, required: false },
		label: { type: String, required: true },
		to: { type: String, required: false },
	},
	computed: {
		style() {
			return {
				'--chip-color': this.color,
			};
		},
	},
};
</script>
